import React from 'react';
import Image from "../Image";
import Images from "../../Images";
import {Carousel} from "antd";
import ButtonComponent from "../Button";
import './styles.less';

const banners = [
    {
        img: <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/detect_theme_page/build/static/media/bannerA.522d62a5.png'} />,
        title: 'Start your AI Powered Shopify store with winning products',
        text: 'A guided step-by-step flow helps you launch a professional store optimized to start selling fast.',
        btnText: 'Build Store',
        link: 'https://app.dropship.io/build-store/step-1',
    },
    {
        img: <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/detect_theme_page/build/static/media/bannerB.751c3bd3.png'} />,
        title: 'Analyze any Shopify store in one click',
        text: 'Install the Dropship Chrome Extension to uncover product data, ad activity, and store analytics instantly.',
        btnText: 'Install Extension',
        link: 'https://chromewebstore.google.com/detail/dropship-product-research/pgccoaecgcgnhffkjjcaonjoockggmng',
    },
];

const Index = () => {
    return (
        <div className="promo-banners-container">
            <Carousel autoplay={true}
                      infinite={true}
            >
                {
                    banners.map(el => (
                        <div className="promo-banner"
                             key={el.title}
                        >
                            <div className="image">
                                {el?.img}
                            </div>
                            <div className="data">
                                <span className="title">
                                    {el?.title}
                                </span>
                                <span className="text">
                                    {el?.text}
                                </span>
                                <ButtonComponent onClick={() => window.open(el?.link, '_blank')}
                                                 className={'btn'}
                                >
                                    {el?.btnText}
                                </ButtonComponent>
                            </div>

                        </div>
                    ))
                }
            </Carousel>
        </div>
    );
};

export default Index;